<template>
  <div>
       <vue-headful
            title="View Cart - Girish Jewellers"
            description="View shopping cart of girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
     
          <section id="main">
             <div class="container">
              <CartList msg="Welcome to Your Vue.js App"/>
             </div>
          </section>


          
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile"/>
    </div>
</template>

<script>
// @ is an alias to /src

import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import CartList from '@/components/CartList.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import vueHeadful from 'vue-headful';



export default {
  name: 'Cart',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    CartList,
    FooterWeb,
    Footer    
  },
   mounted:function(){
      this.loadOnMount();
  },
   data:function(){
      return {};
  },
  watch:{
            
   
  },
  computed:{
    isMobile:function(){
    return Common.isMobile();
    }
  },
  methods:{

      onResize: function() {
    },
      loadOnMount: function() {
        $.get('js/main.js', function(data) {
        eval(data);
        eval('loadFunctions();')
   //process text file line by line
   //$('#div').html(data.replace('n',''));
});
      }

  }
  
}
</script>
